export function processMarkdown(text: string) {
    // for bold **text** becomes <strong>text</strong>
    // for link []() becomes <a href="#"></a>
    // Link [example](http://example.com).
    const htmlText = text.replace(/\*\*([^*]+)\*\*/gim, "<strong>$1</strong>").replace(/\[(.*?)\]\((.*?)\)/gim, "<a href='$2'>$1</a>");
    return htmlText.trim();
}
